export default "__VITE_ASSET__CyO_YET1__"